import { useQuery } from 'react-query'
import { fetchToken } from '../api'
import { FetchTokenResponse } from '../types'

export default function useToken({ tokenUuid }: { tokenUuid?: string }) {
  const { data, isFetching } = useQuery<FetchTokenResponse>(
    ['token', tokenUuid],
    () => {
      return fetchToken(tokenUuid)
    }
  )

  return {
    token: data?.data?.token,
    isFetching
  }
}
